import React from "react";
import { Link } from "react-router-dom";
import { useGetGalleryEventsQuery } from "./galleryEventsApiSlice";

const GalleryEventList = () => {

  const {
    data: response = {},
    isLoading,
    isError,
    error,
  } = useGetGalleryEventsQuery();

  const events = response?.data || [];

  if (isLoading)
    return (
      <div className="container mt-4">
        Loading events...
      </div>
    );

  if (isError)
    return (
      <div className="container mt-4 text-danger">
        {error?.data?.message || "Error loading events"}
      </div>
    );

  return (
    <div className="container mt-4">

      <div className="d-flex justify-content-between align-items-center mb-3">

        <h2>Gallery Events</h2>

        <Link
          to="/dashboard/gallery-events/new"
          className="btn btn-primary"
        >
          + New Event
        </Link>

      </div>

      <div className="card">

        <div className="card-body">

          <table className="table table-bordered table-hover">

            <thead>

              <tr>

                <th>Title</th>

                <th>Year</th>

                <th>Category</th>

                <th>Date</th>

                <th>Location</th>

                <th>Status</th>

                <th>Actions</th>

              </tr>

            </thead>

            <tbody>

              {events.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center">
                    No events found
                  </td>
                </tr>
              )}

              {events.map((event) => {

                const year = event.eventDate
                  ? new Date(event.eventDate).getFullYear()
                  : "-";

                return (

                  <tr key={event._id}>

                    <td>
                      {event.title}
                    </td>

                    <td>
                      {year}
                    </td>

                    <td>
                      {event.category?.title || "-"}
                    </td>

                    <td>
                      {event.eventDate
                        ? new Date(event.eventDate).toLocaleDateString()
                        : "-"}
                    </td>

                    <td>
                      {event.location || "-"}
                    </td>

                    <td>

                      {event.isPublished ? (
                        <span className="badge bg-success">
                          Published
                        </span>
                      ) : (
                        <span className="badge bg-secondary">
                          Draft
                        </span>
                      )}

                    </td>

                    <td>

                      <Link
                        to={`/dashboard/gallery-events/${event._id}`}
                        className="btn btn-sm btn-warning"
                      >
                        Edit
                      </Link>

                    </td>

                  </tr>

                );
              })}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
};

export default GalleryEventList;